import { SuggestionItem } from './types';

export const SUPPORT_SUGGESTIONS: SuggestionItem[] = [
  {
    title: 'Get Softdata Logs',
    subtitle: 'Retrieve detailed logs',
    icon: '📋',
    query: 'Get me softdata logs of consignment 1234',
  },
  {
    title: 'Delivery Summary',
    subtitle: "Today's performance",
    icon: '📊',
    query: "Summarize today's deliveries",
  },
  {
    title: 'Failed Deliveries',
    subtitle: 'Analyze failures',
    icon: '⚠️',
    query: 'What are the top reasons for failed deliveries?',
  },
  {
    title: 'Pending Count',
    subtitle: 'Current status',
    icon: '⏳',
    query: 'How many consignments are pending?',
  },
];

export const BI_SUGGESTIONS: SuggestionItem[] = [
  {
    title: 'Revenue Analytics',
    subtitle: 'Financial insights',
    icon: '📊',
    query: 'Show me revenue analytics for this month',
  },
  {
    title: 'Performance Metrics',
    subtitle: 'KPI dashboard',
    icon: '📋',
    query: 'Generate performance metrics report',
  },
  {
    title: 'Trend Analysis',
    subtitle: 'Data patterns',
    icon: '⚠️',
    query: 'Analyze delivery trends over time',
  },
  {
    title: 'Custom Reports',
    subtitle: 'Build insights',
    icon: '⏳',
    query: 'Create custom analytics report',
  },
];

export const AGENT_CONFIG = {
  SUPPORT: {
    welcomeMessage: 'Hello! I\'m your AI Assistant for the TMS platform. I can help you with consignment tracking, data analysis, API logs, and operational insights. Ask me anything about your deliveries, shipments, or system operations.',
    loadingText: 'Thinking...',
  },
  BI: {
    welcomeMessage: 'Hello! I\'m your BI Agent. I can help you generate reports, analyze trends, and create custom dashboards for your business intelligence needs.',
    loadingText: 'Processing...',
  },
} as const;

export const AGENT_EXECUTION_MAP = {
  filters: 'generateFilters',
  metric: 'generateMetrics',
  chartOptions: 'generateChartOptions',
  havingFilters: 'generateHavingFilters',
  customMetrics: 'generateCustomMetrics',
  customAggregateMetrics: 'generateCustomAggregateMetrics',
} as const;

export const BI_ANALYTICS_URL_PATTERN = '/ops/analytics/visualize'; 